import React from 'react';
import PropTypes from 'prop-types';
import { convertCurrency } from '../../../utils/helpers'
import Image from '../../1_Atoms/Image/Image';
import generalController from '../../../controllers/generalController';
import { languageController } from '../../../controllers/language/languageController';
import { Svg } from '../../1_Atoms/Svg/Svg';
import ReactHtmlParser from 'react-html-parser';

export const Jelly = ({
  topLabel,
  carName,
  carModel,
  carPrice,
  carImg,
  carImgHover,
  isInactive,
  carImageSrc,
  carImageHoverSrc,
  isSelected,
  ...otherProps
}) => {

	const language = generalController.detectLanguage();
  return (
    <div
      className={`mz-jelly ${isInactive ? 'inactive' : ''}`}
      {...otherProps}
    >
      <a className="mz-jelly__inner">
        {topLabel ? 
          <span className="mz-jelly-top">{topLabel}</span>:
          <span className="mz-jelly-top">&nbsp;</span>
        }
        {
          isSelected && (
            <div className="mz-jelly-select-icon">
              <Svg
                type="selected"
                size="1.75"
              />
            </div>
          )
        }
        <div className="mz-jelly-container">
          <Image
            className="mz-jelly-image"
            src={carImageSrc}
            alt={carName}
            isLazy={false}
          />
          <Image
            className="mz-jelly-image--hover"
            src={carImageHoverSrc}
            alt={carName}
            isLazy={false}
          />
        </div>

        <div className="mz-jelly-content">
          <h5>{ReactHtmlParser(carName)}</h5>
          <div className="mz-jelly-content__short-disc">{ReactHtmlParser(carModel)}</div>
        </div>

        {isInactive && <p className="mz-jelly__bottom-text m-0 font-small upper ls-normal text--grey text--center strong">{languageController.getCopy('global', 'unavailableInRegion')}</p>}
      </a>
    </div>
  );
};

Jelly.propTypes = {
  topLabel: PropTypes.string,
  carName: PropTypes.string,
  carModel: PropTypes.string,
  carPrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  carImg: PropTypes.string,
  carImgHover: PropTypes.string,
  isInactive: PropTypes.bool,
  isSelected: PropTypes.bool,
  carImageSrc: PropTypes.string,
  carImageHoverSrc: PropTypes.string,
}

Jelly.defaultProps = {
  topLabel: '',
  carName: '',
  carModel: '',
  carPrice: '',
  carImg: '',
  carImgHover: '',
  isInactive: false,
  isSelected: false,
  carImageSrc: '',
  carImageHoverSrc: '',
}

export default Jelly;